import { HttpClient } from '@angular/common/http';
import { TranslateLoader } from '@ngx-translate/core';
import { all } from 'deepmerge';
import { forkJoin, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ITranslationResource } from './i18n.module';

const cache: { [key: string]: any } = {};

export class CachedHttpTranslationLoader implements TranslateLoader {
  constructor(private http: HttpClient, private resources: ITranslationResource[]) {}

  /**
   * Gets the translations from the server
   */
  public getTranslation(lang: string): Observable<object> {
    const requests = this.resources.map(resource => {
      const path = resource.prefix + lang + resource.suffix;
      if (cache[path]) {
        return of({});
      }
      return this.http.get(path).pipe(
        tap(response => {
          cache[path] = response;
        }),
        catchError(res => {
          console.error('Something went wrong for the following translation file:', path);
          console.error(res.message);
          return of({});
        })
      );
    });
    return forkJoin(requests).pipe(map(response => all(response)));
  }
}
